import { hasAppInteriorGrant } from '@/features/auth/accessPolicy'

import type { CommandDeckPreviewBundle, UserAccessSnapshot } from '../contracts/types'
import { createCommandDeckMissionReadModel } from '../readModel/createCommandDeckMissionReadModel'
import type { CommandDeckMissionReadModelReaders } from '../readModel/commandDeckMissionReadModel.types'
import { defaultCommandDeckMissionReaders } from '../readModel/readers/defaultCommandDeckMissionReaders'
import { mapPersonalizationToPreviewBundle } from './mapPersonalizationToPreviewBundle'
import { resolveCommandDeckPersonalizationState } from './resolveCommandDeckPersonalizationState'

export interface CommandDeckLiveBundle {
  bundle: CommandDeckPreviewBundle
  /** True when user has an interior grant (e.g. creator_beta) — full deck posture. */
  unlocked: boolean
}

export interface CommandDeckLiveBundleOptions {
  uid?: string
  pathname?: string
  readers?: CommandDeckMissionReadModelReaders
}

/**
 * Build Command Deck data from live UserAccessSnapshot (AuthSessionProvider truth).
 * Mission context is loaded read-only via mission read model — no ORBIS default on failure.
 */
export function getCommandDeckLiveBundle(
  access: UserAccessSnapshot,
  options: CommandDeckLiveBundleOptions = {}
): CommandDeckLiveBundle {
  const readers = options.readers ?? defaultCommandDeckMissionReaders
  const readModel = createCommandDeckMissionReadModel(
    {
      access,
      uid: options.uid,
      pathname: options.pathname,
    },
    readers
  )

  const personalization = resolveCommandDeckPersonalizationState({
    mode: 'live',
    access,
    accessProfileId: hasAppInteriorGrant(access) ? 'creator_beta' : 'visitor',
    missionHint: readModel.missionHint,
    liveMissionContext: readModel.liveMissionContext,
  })

  return {
    unlocked: personalization.hold.unlocked,
    bundle: mapPersonalizationToPreviewBundle(personalization),
  }
}
